import { useI18n } from '../lib/i18n';
import { Button } from '../components/ui/button';

export default function LangSwitch({ className = '' }) {
  const { lang, toggleLang } = useI18n();
  return (
    <Button
      data-testid="lang-switch"
      variant="ghost"
      size="sm"
      className={`text-xs font-semibold px-2 h-7 rounded-md border border-[#2D2E3D] hover:bg-[#1E1F2E] ${className}`}
      onClick={toggleLang}
    >
      <span className={lang === 'fr' ? 'text-white' : 'text-[#64748B]'}>FR</span>
      <span className="text-[#2D2E3D] mx-1">|</span>
      <span className={lang === 'en' ? 'text-white' : 'text-[#64748B]'}>EN</span>
    </Button>
  );
}
